import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
`;

export const SkeletonBox = styled.div`
  display: block;
  background: #eef1f5;
  border-radius: ${props => props.$radius || '8px'};
  height: ${props => props.$h || '16px'};
  animation: ${pulse} 1.2s ease-in-out infinite;
`;

export const SkeletonLine = styled(SkeletonBox)`
  height: ${props => props.$h || '12px'};
  width: ${props => props.$w || '100%'};
`;

export const SkeletonCircle = styled(SkeletonBox)`
  border-radius: 50%;
`;


